import { render, staticRenderFns } from "./SettingDoctorSayInfoDB.vue?vue&type=template&id=7dee1d34&scoped=true&"
import script from "./SettingDoctorSayInfoDB.vue?vue&type=script&lang=js&"
export * from "./SettingDoctorSayInfoDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dee1d34",
  null
  
)

export default component.exports